import {
  GTA5_CLOSE_LABEL_TZ,
  GTA5_GIVEAWAY_CLOSE_AT,
  GTA5_GIVEAWAY_ENTER_PATH,
  GTA5_GIVEAWAY_OPEN_AT,
} from "@/constants/gta5-giveaway";

// 전역 상단 띠 프로모 배너(PromoBanner)용 게이트 상수.
// 배너 노출 여부 + 문구 + 링크 목적지를 단일 출처로 둔다.
//   마운트 실측 **8곳 / 7파일**(2026-09-09 `git grep -c "<PromoBanner" -- src`).
//   두 벌이 되면 화면마다 다른 마감일이 나간다.
//
// ⚠️ 마감은 "미국 태평양시(PT) 7/27 자정"이다 = 7/28 00:00 PDT(UTC-7) = 2026-07-28T07:00:00Z.
//   → 7/27 PDT 하루 종일 노출되고 7/28 00:00 PDT 에 숨김. KST 로는 7/28 16:00.
//   - 게이트 컷오프(deadline)와 표기일(endsMonth/endsDay)을 "분리"한다:
//     · 타임존 파생(toLocaleDateString/Intl+timeZone)은 Node vs 브라우저 ICU 차이로 hydration mismatch 위험.
//     → 표기는 상수로 고정(안전), 게이트만 instant 비교. 7/27 내내 유효하니 "Ends Jul 27" 표기 유지.
//   - (한국시로 변경 가능성 있음: 그때 deadline = KST 기준 UTC instant 로, endsDay 는 KST 캘린더 날짜로 갱신.)

export const PROMO_BANNER = {
  // ★ 캠페인 on/off 킬 스위치. false 면 시계와 무관하게 배너를 아예 렌더하지 않는다.
  //   deadline 게이트는 "클라이언트 시계"라 시계가 틀어진 기기에선 만료된 캠페인이 계속 보일 수 있다.
  //   → 캠페인이 끝나면 이 값을 false 로 내려 그 노출까지 차단한다(마운트 8곳은 그대로 둠).
  //   다음 캠페인 재활성 절차: enabled=true + deadline/href/copy/promotionId 갱신.
  enabled: true,
  // 배너 클릭 시 이동. 현 캠페인(GTA5 기브어웨이)은 **응모 폼**으로 바로 내린다.
  //   그냥 랜딩으로 보내면 히어로·3스텝을 다시 스크롤해야 한다(gta5-giveaway.ts 앵커 주석).
  href: GTA5_GIVEAWAY_ENTER_PATH,
  // GA4 `view_promotion`·`select_promotion` 의 `promotion_id`(D1). 캠페인마다 바꾼다 — 안 바꾸면 다음 캠페인의
  //   노출·클릭이 이전 캠페인 이름으로 쌓인다. 로케일과 무관한 고정 키(`use-promotion-tracking.ts`).
  promotionId: "gta5-giveaway",
  // ★ 시작 컷오프 — 이 시각 **전에는** 안 뜬다. GTA5 노출 시각과 같은 상수를 본다.
  //   종전엔 이 게이트가 없었다(마감만). 캠페인이 시작 전부터 뜨면 안 된다.
  startAt: GTA5_GIVEAWAY_OPEN_AT.toISOString(),
  // 마감 컷오프(이 시각 이후 자동 숨김). GTA5 마감과 같은 상수.
  deadline: new Date(GTA5_GIVEAWAY_CLOSE_AT.getTime() + 1).toISOString(),

  /**
   * ★**카피는 `t()` 를 안 쓴다 — 이 캠페인은 영문 한 벌이다.**
   *
   * 이 리포는 **키가 곧 영문 표시문**이라, 새 키를 `en` 에만 넣으면 다른 로케일 사용자에게
   * 영문이 나가고 `locale-key-parity` ratchet 이 그걸 **결함으로** 잡는다. 7로케일에 영문을
   * 복사해 넣는 것도 같은 가드가 말하는 「잘못된 수정」이다.
   *
   * GTA5 는 시안·구글폼이 영어 전용이라 캠페인 전체가 영문 한 벌이다
   * (`constants/gta5-giveaway.ts` 의 `COPY` 와 같은 결정). 번역하기로 정해지면 그때
   * 두 곳을 함께 사전으로 옮긴다.
   */
  /**
   * ★**`message` 에 「Giveaway」를 안 붙인다 — `meets` 가 뒤 명사를 목적어로 먹는다.**
   *
   * 종전엔 `GTA V x TactSuit Giveaway` 였다. `x` 는 **복합 명사구**라 `[GTA V x
   * TactSuit] Giveaway`(그 이름의 기브어웨이)로 읽혔는데, 2026-09-16 에 `x` 가 공식
   * 콜라보로 오해된다는 지적으로 `meets` 로 바꾸면서 구조가 **절**이 됐다:
   *
   * ```
   *   GTA V meets [TactSuit Giveaway]     ← 정동사가 뒤 명사를 목적어로 빨아들인다
   * ```
   *
   * 「GTA V 가 TactSuit *기브어웨이를* 만난다」로 먼저 읽힌다. 그래서 명사를 뺐다 —
   * 형제 문구(`detail` 「Win 1 of …」 · `cta` 「Enter Now」)가 구분선 하나 건너에 있어
   * 기브어웨이라는 사실은 그쪽이 전달한다.
   *
   * ⚠️ **로케일마다 결론이 다르다. 누락이 아니다**(`gnb.json` 의 `promoGta5Message`):
   *
   * ```
   *   en · de     명사 없음          ← 명사가 뒤에 인접해 위 오독이 난다
   *   fr · es     명사가 **앞**       Jeu-concours … / Sorteo …        그대로 둔다
   *   kr·jp·cn    명사가 뒤          이벤트 / キャンペーン / 活动      CJK 는 라틴 구간을
   *                                                                  고유명으로 읽어 안 걸린다
   * ```
   *
   * 즉 기준은 「언어」가 아니라 **명사가 절 뒤에 인접하는가**다. 새 로케일을 넣을 때
   * 그 술어로 판단한다.
   *
   * ⚠️ SEO `<title>` 은 **다른 결론**이다 — 검색결과에 「기브어웨이」가 있어야 해서
   * 그 단어를 남기되 **구분자로 절을 닫았다**(`GTA V meets TactSuit - Giveaway |
   * bHaptics`, `pages/event/gta5-giveaway.tsx`). 배너는 옆 칸의 `detail`·`cta` 가
   * 그 사실을 대신 전달하지만 title 은 **혼자 선다.**
   */
  copy: {
    message: "GTA V meets TactSuit",
    detail: "Win 1 of 10 TactSuit Pro",
    ends: `Ends ${GTA5_CLOSE_LABEL_TZ}`,
    cta: "Enter Now",
  },
} as const;

/**
 * ★**서버가 내려준 「창 안인가」를 담는 전역 키** (#5702).
 *
 * `_document` 가 서버 시계로 판정해 인라인 스크립트로 세우고, `PromoBanner` 가 읽는다.
 * 두 곳이 같은 문자열을 써야 하므로 상수로 둔다 — 손으로 두 번 적으면 한쪽 오타가
 * `undefined` 가 되고 그건 **조용히 「닫힘」**으로 읽힌다.
 *
 * ⚠️ 캠페인 이름을 키에 박지 않는다. `_document` 는 앱 전역 파일이라 다음 캠페인이
 * 이 자리를 그대로 재사용한다.
 */
export const PROMO_WINDOW_GLOBAL = "__BH_PROMO_WINDOW__";

/**
 * 띠를 지금 띄워도 되나.
 *
 * ## ★★판정을 **두 벌로 두지 않는다** — 창 여부는 `isWithinEntryWindow` 의 답을 받는다
 *
 * 팝업(`isGta5GiveawayOpen`)과 같은 응모 창이다. 띠는 그 답을 `_document` 가 서버 시계로
 * 잰 값(`withinWindow`)으로 받고, 여기엔 `enabled` 킬 스위치만 남는다. 술어가 두 벌이면
 * 「띠는 떴는데 눌러 보니 404」가 난다.
 *
 * 환경과 무관하다(#6149 · 2026-11-03). 종전엔 *"띠도 dev 에서는 보이고 prod 는 gta5-giveaway
 * 시간과 같게"*(작성자 2026-09-10)라 비-prod 는 항상 보였고, 그래서 응모가 끝난 뒤에도
 * dev·local 에 띠가 남았다.
 *
 * ⚠️ 시간 소스는 여전히 **클라이언트**다 — 이 함수의 `now` 기본값이 `new Date()` 이고
 * 유일한 호출처(`PromoBanner.tsx`)가 렌더에서 부르기 때문이다. 팝업·랜딩은 서버 판정이라
 * 시계가 틀어진 기기에서는 띠만 먼저 보일 수 있다. **받아들인 이유와 「무엇이 바뀌면
 * 서버로 올려야 하나」는 `PromoBanner` docblock** 에 있다 — 거기가 그 판단의 자리다.
 */
export const isPromoBannerActive = ({
  withinWindow,
}: {
  withinWindow: boolean;
}): boolean => PROMO_BANNER.enabled && withinWindow;
